import { render, staticRenderFns } from "./searchBox.vue?vue&type=template&id=0d4f7742&scoped=true"
import script from "./searchBox.vue?vue&type=script&lang=js"
export * from "./searchBox.vue?vue&type=script&lang=js"
import style0 from "./searchBox.vue?vue&type=style&index=0&id=0d4f7742&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4f7742",
  null
  
)

export default component.exports